import React from 'react';

// Control de intensidad sin frecuencia cardíaca, para quien toma
// betabloqueante: la FC queda frenada y las zonas por FC no sirven. Percepción
// de esfuerzo (Borg 6-20) y test del habla, rangos de ACSM (Guidelines for
// Exercise Testing and Prescription, 11.ª ed.). Mantener en sync con
// CONTROL_SIN_FC en backend/decision_presentation.py.
export const CONTROL_SIN_FC = [
  { key: 'light', label: 'Leve', borg: '9-11', habla: 'Habla y hasta podría cantar',
    box: 'border-sky-200 bg-sky-50', title: 'text-sky-700', value: 'text-sky-800' },
  { key: 'moderate', label: 'Moderada', borg: '12-13', habla: 'Puede hablar, pero no cantar',
    box: 'border-emerald-200 bg-emerald-50', title: 'text-emerald-700', value: 'text-emerald-800' },
  { key: 'vigorous', label: 'Vigorosa', borg: '14-17', habla: 'Solo unas palabras sin pausa',
    box: 'border-amber-200 bg-amber-50', title: 'text-amber-700', value: 'text-amber-800' },
];

export const NOTA_SIN_FC = 'Toma betabloqueante: la frecuencia cardíaca está frenada y no sirve para '
  + 'controlar la intensidad. Control por percepción de esfuerzo (Borg 6-20) y test del habla.';

/**
 * Reemplaza las zonas de FC cuando la persona toma betabloqueante.
 * `unlock` (opcional): lo que habilita el escenario; lo bloqueado se muestra
 * atenuado con su motivo, igual que las zonas de FC.
 */
export default function ControlSinFC({ unlock }) {
  return (
    <div className="space-y-3" data-testid="control-sin-fc">
      <p className="text-sm text-slate-600 bg-slate-50 border border-slate-200 rounded-lg p-3">{NOTA_SIN_FC}</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {CONTROL_SIN_FC.map((z) => {
          const habilitada = !unlock || unlock[z.key]?.enabled;
          return habilitada ? (
            <div key={z.key} className={`p-4 rounded-xl border ${z.box}`} data-testid={`sin-fc-${z.key}`}>
              <p className={`text-xs font-medium uppercase tracking-wider mb-1 ${z.title}`}>{z.label}</p>
              <p className={`text-xl font-bold ${z.value}`}>Borg {z.borg}</p>
              <p className="text-sm text-slate-600 mt-1">{z.habla}</p>
            </div>
          ) : (
            <div key={z.key} className="p-4 rounded-xl border border-gray-200 bg-gray-50 opacity-70" data-testid={`sin-fc-${z.key}-blocked`}>
              <p className="text-xs font-medium uppercase tracking-wider mb-1 text-gray-500">{z.label}</p>
              <p className="text-xs italic text-gray-500 leading-relaxed">{unlock[z.key].reason}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
